<template>
  <router-view></router-view>
</template>
<script>
/**
 * TODO
 */

export default {
  name: "Reports",
  data() {
    return {};
  },
  props: {},
  created() {},
  components: {},
  computed: {},
  methods: {},
  filters: {}
};
</script>
